function fixSlideTextSizes() {
  if (window.innerWidth > 749) return;

  document.querySelectorAll('.slide__content').forEach(function (slideContent) {
    var textBlocks = slideContent.querySelectorAll('.text-block');

    textBlocks.forEach(function (block, index) {
      if (index === 0) {
        block.style.setProperty('--font-size', '22px', 'important');
      } else {
        block.style.setProperty('--font-size', '15px', 'important');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', fixSlideTextSizes);
window.addEventListener('resize', fixSlideTextSizes);